
import React, { useEffect } from 'react';
import { useBooking } from './BookingModal';

const AutoPopup = () => {
    const { openBooking } = useBooking();

    useEffect(() => {
        const timer = setTimeout(() => {
            // Check if we should show the popup (e.g. not already shown in this session)
            // For now, based on the requirement "automatic form pops up after 10 seconds when the customer enters the website",
            // we will just trigger it. 
            // We could add sessionStorage check here if needed to prevent annoyance on every reload.

            const hasPopupShown = sessionStorage.getItem('hasPopupShown');

            if (!hasPopupShown) {
                openBooking();
                sessionStorage.setItem('hasPopupShown', 'true');
            }
        }, 10000); // 10 seconds

        return () => clearTimeout(timer);
    }, [openBooking]);

    return null; // This component doesn't render anything
};

export default AutoPopup;
